export type CustomerDetailsApprovalTranslation = {
  approvedBy: string;
  ariaLabel: string;
  button: {
    approve: string;
    reject: string;
    resubmit: string;
  };
  prospectInfo: string;
  rejectDialog: {
    cancel: string;
    description: string;
    reason: string;
    submit: string;
    title: string;
  };
  rejectedBy: string;
  rejectedInfo: string;
  rejectionReason: string;
  toast: {
    approved: string;
    rejected: string;
    resubmitted: string;
  };
};

export const customerDetailsApprovalTranslation: CustomerDetailsApprovalTranslation = {
  approvedBy: 'Zatwierdził(a) {{user}}, {{date}}',
  ariaLabel: 'Zatwierdzenie klienta',
  button: {
    approve: 'Zatwierdź',
    reject: 'Odrzuć',
    resubmit: 'Zgłoś ponownie',
  },
  prospectInfo:
    'Prospekt czeka na zatwierdzenie. Do czasu zatwierdzenia nie można tworzyć dla niego procesów ani ofert.',
  rejectDialog: {
    cancel: 'Anuluj',
    description:
      'Podaj powód odrzucenia. Klient pozostanie w bazie jako odrzucony i można go będzie zgłosić ponownie.',
    reason: 'Powód odrzucenia',
    submit: 'Odrzuć klienta',
    title: 'Odrzuć klienta',
  },
  rejectedBy: 'Odrzucił(a) {{user}}, {{date}}',
  rejectedInfo:
    'Klient został odrzucony. Nie można tworzyć dla niego procesów ani ofert, dopóki nie zostanie zatwierdzony.',
  rejectionReason: 'Powód odrzucenia',
  toast: {
    approved: 'Klient został zatwierdzony',
    rejected: 'Klient został odrzucony',
    resubmitted: 'Klient został ponownie zgłoszony do zatwierdzenia',
  },
};
